export default String.raw`
.check-deliveries.dialog.middle {
        max-width: 520px;
}
`